export const useReplaceErrorMessage = (errorMessage: string, name: string, placeholder: string) => {
  if (errorMessage) {
    return errorMessage.replace(name, placeholder.toLowerCase())
  }

  return errorMessage
}
